import React from 'react';

import config from './Config'

import appstore from './Assets/appstore.png'
import googleplay from './Assets/googleplay.png'

import './Hero.css';

const Hero = () => {
    return (
        <section id="hero" className="hero">
            <div className="hero_content">
                <div className="hero_text">
                    <h1 className="hero_headline">
                        QuickFix – FAST REPAIR SERVICES
                    </h1>
                    <p className="hero_subheadline">
                        Fast reliable repairs.
                    </p>
                    <div className="">
                        <a href="#" className="">
                            <img src={appstore} alt="Download on App Store" className="download_icon" />
                        </a>

                        <a href={config.playstorelink} className="">
                            <img src={googleplay} alt="Get it on Google Play" className="download_icon" />
                        </a>
                    </div>
                </div>

                <div className="hero_image">

                </div>
            </div>
        </section>
    );
};

export default Hero;
